<template>
  <div>
    <div class="d-flex flex-wrap justify-content-between align-items-start mb-1">
      <div class="mr-1">
        <h4 class="mb-0">
          Роли
        </h4>
        <div class="text-muted small">
          Роль — набор прав. У пользователя может быть несколько ролей, права складываются. Изменения действуют сразу,
          без перелогина. «Суперадмин» и «Админ» — системные: их права задаются в коде.
        </div>
      </div>
      <b-button
        variant="primary"
        class="mt-50"
        :to="{ name: 'acl-role', params: { id: 'new' } }"
      >
        <feather-icon icon="PlusIcon" /> Новая роль
      </b-button>
    </div>

    <b-alert
      v-if="errorText"
      show
      variant="danger"
    >
      <div class="alert-body">
        {{ errorText }}
      </div>
    </b-alert>

    <b-card no-body>
      <b-table
        :items="roles"
        :fields="fields"
        :busy="loading"
        hover
        responsive
        show-empty
        empty-text="Ролей нет"
        class="mb-0"
        @row-clicked="open"
      >
        <template #table-busy>
          <div class="text-center py-1">
            <b-spinner small />
          </div>
        </template>
        <template #cell(name)="{ item }">
          <div class="font-weight-bold">
            {{ item.name }}
            <b-badge
              v-if="item.isSystem"
              variant="light-secondary"
              class="ml-50"
            >
              системная
            </b-badge>
          </div>
          <div
            v-if="item.description"
            class="small text-muted"
          >
            {{ item.description }}
          </div>
        </template>
        <template #cell(permissions)="{ item }">
          <span v-if="item.key === 'superadmin'">все, включая системные</span>
          <span v-else-if="item.key === 'admin'">все, кроме системных</span>
          <span v-else>{{ item.permissions.length }}</span>
        </template>
        <template #cell(actions)="{ item }">
          <div class="text-nowrap">
            <b-button
              v-if="!item.isSystem"
              v-b-tooltip.hover
              title="Копировать"
              variant="flat-secondary"
              size="sm"
              @click.stop="copy(item)"
            >
              <feather-icon icon="CopyIcon" />
            </b-button>
            <b-button
              v-if="!item.isSystem"
              v-b-tooltip.hover
              title="Удалить"
              variant="flat-danger"
              size="sm"
              @click.stop="remove(item)"
            >
              <feather-icon icon="TrashIcon" />
            </b-button>
          </div>
        </template>
      </b-table>
    </b-card>
  </div>
</template>

<script>
import {
  BAlert, BBadge, BButton, BCard, BSpinner, BTable, VBTooltip,
} from 'bootstrap-vue'
import aclApi from '@/services/acl-api.service'

export default {
  name: 'AclRolesPage',
  components: {
    BAlert, BBadge, BButton, BCard, BSpinner, BTable,
  },
  directives: { 'b-tooltip': VBTooltip },
  data() {
    return {
      roles: [],
      loading: false,
      errorText: '',
      fields: [
        { key: 'name', label: 'Роль' },
        { key: 'permissions', label: 'Прав' },
        { key: 'users', label: 'Пользователей' },
        { key: 'actions', label: '', class: 'text-right' },
      ],
    }
  },
  created() {
    this.load()
  },
  methods: {
    async load() {
      this.loading = true
      this.errorText = ''
      try {
        this.roles = (await aclApi.roles()).data
      } catch (e) {
        this.errorText = e?.response?.data?.message || 'Не удалось загрузить роли'
      } finally {
        this.loading = false
      }
    },
    open(role) {
      this.$router.push({ name: 'acl-role', params: { id: role.id } })
    },
    copy(role) {
      this.$router.push({ name: 'acl-role', params: { id: 'new' }, query: { from: role.id } })
    },
    async remove(role) {
      const text = role.users
        ? `Роль «${role.name}» снимется с ${role.users} пользователей. Удалить?`
        : `Удалить роль «${role.name}»?`
      const ok = await this.$bvModal.msgBoxConfirm(text, {
        title: 'Удаление роли', okVariant: 'danger', okTitle: 'Удалить', cancelTitle: 'Отмена', centered: true,
      })
      if (!ok) return
      try {
        await aclApi.deleteRole(role.id)
        await this.load()
      } catch (e) {
        // the global toast already shows the reason
      }
    },
  },
}
</script>
